import React, { Component } from 'react';

import logoWhiteImage from '../images/logoWhite.svg';

export default class Logo extends Component {
  render() {
    return <img alt="Logo" height="59px" src={logoWhiteImage} />;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Logo.jsx
 **/